import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useSelector } from 'react-redux'
import { RootState } from '@/store/rootReducer'
import { sendUserDetailsToSW } from '@/serviceworker/mediator'

export function useSentryUser() {
  const user = useSelector((state: RootState) => state.auth.user)

  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        username: user.name,
      })

      sendUserDetailsToSW();
    }
  }, [user])
}
